module.exports = __webpack_public_path__ + "img/BH.a9e16e65.svg";